import { useCallback, useState } from 'react'
import { Spinner, Stack } from 'react-bootstrap'

import styled from 'styled-components'
import { StringParam, useQueryParam } from 'use-query-params'

import { DataRecords } from '@piv/lib/rest-queries'
import { RecordModal } from '@piv/portal/app/Drilldown/RecordModal'
import { Button } from '@piv/portal/primitives/Buttons'
import {
  ResultList,
  SearchResultRow,
} from '@piv/portal/primitives/SearchResultRow'
import { SearchTextField } from '@piv/portal/primitives/SearchTextField'

import { useInventoryFilterParams } from './useInventoryFilterParams'

const LoadMoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`

export function InventoryRecordSearch() {
  const { queryString, setQueryString } = useInventoryFilterParams()
  const [previewId, setPreviewId] = useQueryParam('preview', StringParam)
  const [previewDataPackageId, setPreviewDataPackageId] = useState('')
  const previewRecordId = previewId ? previewId : false
  const searchResults = DataRecords.useSearchedDataRecords(queryString ?? '')

  const handleClick = useCallback(
    (recordName: string, dataPackageId: string) => {
      setPreviewId(recordName)
      setPreviewDataPackageId(dataPackageId)
    },
    [setPreviewId, setPreviewDataPackageId]
  )

  const handleClose = useCallback(() => {
    setPreviewId(null, 'replaceIn')
    setPreviewDataPackageId('')
  }, [setPreviewId, setPreviewDataPackageId])

  return (
    <Stack gap={3}>
      <SearchTextField
        placeholder="Search for a Record"
        aria-label="Search for a Record"
        aria-describedby="record-search"
        id="record-search"
        value={queryString ?? ''}
        onChange={(e) => setQueryString(e.target.value || undefined)}
      />
      {searchResults.isFetching && queryString && (
        <Spinner animation="border" size="sm" />
      )}
      <ResultList id="search-results">
        {(!searchResults.isFetching || searchResults.isFetchingNextPage) &&
          searchResults.data?.pages
            .flatMap(({ data }) => data)
            .map(({ recordName, recordDescription, dataPackageIds }) => {
              const firstDataPackageId = dataPackageIds[0]
              if (!firstDataPackageId) {
                return null
              }
              return (
                <SearchResultRow
                  key={recordName}
                  title={recordName}
                  subtitle={recordDescription}
                  onClick={() => handleClick(recordName, firstDataPackageId)}
                />
              )
            })}
      </ResultList>
      {searchResults.hasNextPage && (
        <LoadMoreButtonContainer>
          <Button
            onClick={() => searchResults.fetchNextPage()}
            loading={searchResults.isFetchingNextPage}
            id="search-load-more"
          >
            Load More
          </Button>
        </LoadMoreButtonContainer>
      )}
      <RecordModal
        dataPackageId={previewDataPackageId}
        recordId={previewRecordId}
        onClosed={handleClose}
      />
    </Stack>
  )
}
